import React from 'react';
import styled from 'styled-components';

export interface HtmlInfoPanelProps {
  heading: string;
  htmlArray?: string[];
  className?: string;
}

const Heading = styled.p`
  ${({ theme }) => theme.fontSize.M16};
  color: ${({ theme }) => theme.colors.GREY};

  &:after {
    content: '';
    display: block;
    padding-top: ${({ theme }) => theme.spacing.S8};
    border-bottom: 1px solid ${({ theme }) => theme.colors.GREY_LIGHT};
  }
`;

const ListContainer = styled.ul`
  ${({ theme }) => theme.fontSize.M14};
  padding: ${({ theme }) => theme.spacing.S8};
  color: ${({ theme }) => theme.colors.GREY};

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.BLUE};
  }
`;

const ListItem = styled.li`
  margin-bottom: ${({ theme }) => theme.spacing.S8};

  &:last-child {
    margin-bottom: 0;
  }
`;

const HtmlInfoPanelContainer = styled.div`
  max-width: 272px;
`;

function HtmlInfoPanel({ heading, htmlArray, className }: HtmlInfoPanelProps) {
  // create object for working with dangerouslySetInnerHTML as per https://reactjs.org/docs/dom-elements.html
  function createMarkup(text: string) {
    return { __html: text };
  }

  function buildList(input: string[]) {
    return input.map((entry: string, index: number) => (
      <ListItem key={index} dangerouslySetInnerHTML={createMarkup(entry)} />
    ));
  }

  return (
    <HtmlInfoPanelContainer className={className}>
      <Heading>{heading}</Heading>
      {htmlArray && <ListContainer>{buildList(htmlArray)}</ListContainer>}
    </HtmlInfoPanelContainer>
  );
}

export { HtmlInfoPanel };
